module.exports = __webpack_public_path__ + "img/card-ico.77ac7353.png";